import { queryOptions, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  actualizarCelular,
  cambiarPreferencia,
  desvincularTelegram,
  eliminarSuscripcionPush,
  generarEnlaceTelegram,
  listarMisPreferencias,
  obtenerMisCanales,
} from "../services/perfil-notificaciones.api";

export const misCanalesQueryOptions = queryOptions({ queryKey: qk.misCanalesNotif, queryFn: obtenerMisCanales });

export function useMisCanales(opts?: { sondear?: boolean }) {
  // Mientras se espera la vinculación de Telegram se pregunta cada 3 s (el bot la registra por sondeo).
  return useQuery({ ...misCanalesQueryOptions, refetchInterval: opts?.sondear ? 3000 : false });
}

export const misPreferenciasQueryOptions = queryOptions({ queryKey: qk.misPreferenciasNotif, queryFn: listarMisPreferencias });

export function useMisPreferencias() {
  return useQuery(misPreferenciasQueryOptions);
}

export function useActualizarCelular() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: actualizarCelular,
    onSuccess: (_, celular) => {
      toastExito({ title: celular ? "Celular guardado" : "Celular eliminado", message: celular ? "Lo usaremos para SMS y WhatsApp." : undefined });
      void qc.invalidateQueries({ queryKey: qk.misCanalesNotif });
      void qc.invalidateQueries({ queryKey: qk.miPerfil });
    },
    onError: toastErrorApi,
  });
}

export function useGenerarEnlaceTelegram() {
  return useMutation({ mutationFn: generarEnlaceTelegram, onError: toastErrorApi });
}

export function useDesvincularTelegram() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: desvincularTelegram,
    onSuccess: () => {
      toastExito({ title: "Telegram desvinculado" });
      void qc.invalidateQueries({ queryKey: qk.misCanalesNotif });
    },
    onError: toastErrorApi,
  });
}

export function useEliminarSuscripcionPush() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: eliminarSuscripcionPush,
    onSuccess: () => {
      toastExito({ title: "Dispositivo quitado", message: "Ya no recibirá notificaciones del navegador." });
      void qc.invalidateQueries({ queryKey: qk.misCanalesNotif });
    },
    onError: toastErrorApi,
  });
}

export function useCambiarPreferencia() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: cambiarPreferencia,
    onSuccess: () => void qc.invalidateQueries({ queryKey: qk.misPreferenciasNotif }),
    onError: toastErrorApi,
  });
}
